export default "__VITE_ASSET__e9fb185c__"